module.exports = __webpack_public_path__ + "static/img/food-policy024.5400e93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy024.png
// module id = S1so
// module chunks = 1